import { Chip } from "@/components/badge/chip";
import { priorityOf } from "@/constants/priorities";
import { cn } from "@/lib/utils";
import type { Engagement } from "@/types/domain";

/** Read-only P0–P3 chip, tinted by urgency. */
export const PriorityChip = ({
  engagement,
  className,
}: {
  engagement: Engagement;
  className?: string;
}) => {
  const { label, tone } = priorityOf(engagement);
  return (
    <Chip tone={tone} title="优先级" className={cn("shrink-0 tabular-nums", className)}>
      {label}
    </Chip>
  );
};
